import { render, staticRenderFns } from "./ColorSpectrum.vue?vue&type=template&id=bda8dae4&"
import script from "./ColorSpectrum.vue?vue&type=script&lang=ts&"
export * from "./ColorSpectrum.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports